<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2022-03-07 15:13:11
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Roster\RosterForm\viewRosterForm.vue
 -->
<template>
  <ContentLayout
    :title="
      iSEdited
        ? $t('label_essweb_RosterForm_form_editTitle')
        : $t('label_essweb_RosterForm_form_viewTitle')
    "
    widthClass="max-1000"
    :delBtn="hasBtn('delete-admin-roster-form-template')"
    backgroundClass="white"
    :editBtn="!iSEdited && hasBtn('edit-admin-roster-form-template')"
    @edit="iSEdited = true"
    :initData="rosterFormData"
    @change="(changed) => (isChanged = changed)"
    :checkData="['roster_form_name', 'roster_property_group_uuid', 'remarks']"
    @delete="
      $confirmDo($t('label_essweb_RosterForm_list_title')).then((res) => {
        res ? toDelete() : null;
      })
    "
  >
    <!-- content -->
    <template v-slot:page-main>
      <v-container fluid class="pa-0">
        <v-form ref="form" lazy-validation>
          <v-row>
            <v-col xs="12" sm="6" md="6" lg="6" cols="12">
              <inputTextFiledMultiLang
                :filled="iSEdited"
                :readonly="!iSEdited"
                :bindData="rosterFormData.roster_form_name"
                @change="
                  (valueArr) => {
                    rosterFormData.roster_form_name = valueArr;
                  }
                "
                :label="$t('label_essweb_RosterForm_form_rosterFormNameLabel')"
                :rules="$GetRules(['_Require_Rules'], [null])"
              />
            </v-col>
            <v-col xs="12" sm="6" md="6" lg="6" cols="12">
              <AutoComplete
                isRequired
                label="label_essweb_RosterForm_form_rosterFormGroupLabel"
                :items="RosterPropertyGroup"
                item-text="roster_property_group_name"
                item-value="uuid"
                :filled="iSEdited"
                :readonly="!iSEdited"
                v-model="rosterFormData.roster_property_group_uuid"
                :rules="$GetRules(['_Require_Rules'], [null])"
              >
              </AutoComplete>
            </v-col>
            <v-col xs="12" sm="12" md="12" lg="12" cols="12">
              <inputTextFiledMultiLang
                :filled="iSEdited"
                :readonly="!iSEdited"
                :bindData="rosterFormData.roster_form_description"
                @change="
                  (valueArr) => {
                    rosterFormData.roster_form_description = valueArr;
                  }
                "
                :label="
                  $t('label_essweb_RosterForm_form_rosterFormDescriptionLabel')
                "
              />
            </v-col>
          </v-row>
        </v-form>
        <Tabler
          :headers="headers"
          :items="desserts"
          :showSelect="showSelect"
          border
        >
          <template v-slot:item.shift_type="{ item }">
            <span
              class="text--primary table-title"
              v-for="(it, index) in item.ess_att_shift_type"
              :key="index"
            >
              {{ $getCommonLangValue(it.shift_type_name) }}
              <span v-if="index < item.ess_att_shift_type.length - 1">,</span>
            </span>
          </template>
          <template v-slot:item.shift_name="{ item }">
            <div class="text--primary table-title">
              {{ $getCommonLangValue(item.shift_name) }}
            </div>
          </template>
          <template v-slot:item.time="{ item }">
            <div class="text--primary table-title">
              {{
                $timeMachine(item.start_utc_time) +
                " - " +
                $timeMachine(item.end_utc_time)
              }}
            </div>
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn icon @click="toDeleteShift(item.uuid)" v-if="iSEdited">
              <span class="material-icons-round">delete</span>
            </v-btn>
          </template>
        </Tabler>
        <v-container fluid class="pa-0" v-if="iSEdited">
          <v-btn
            text
            small
            class="my-2 text-capitalize"
            color="primary"
            @click="showNewShift = true"
          >
            {{ $t("label_essweb_RosterForm_form_newShiftBtnLabel") }}
            <span class="material-icons-round">add</span>
          </v-btn>
        </v-container>
      </v-container>
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        v-if="iSEdited"
        saveBtn
        @save="toSave"
        @cancel="toBack(isChanged)"
      />
    </template>
    <!-- actions -->
    <!-- tools -->
    <template v-slot:tools-main>
      <newShiftDialog
        :show="showNewShift"
        @onNew="onNewShift"
        :curUuid="curUuid"
        @close="showNewShift = false"
      />
    </template>
    <!-- tools -->
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
import newShiftDialog from "@/Page/EssAdmin/Roster/RosterForm/components/newShiftDialog";
export default {
  name: "editRosterForm",
  components: { newShiftDialog },
  computed: {
    ...mapGetters(["companyLang", "staticZone", "defaultUTC"]),
    RosterPropertyGroup() {
      return this.$getSelectTrans(
        this.RosterPropertyGroupData,
        "roster_property_group_name"
      );
    },
    curUuid() {
      let arr = [];
      this.desserts.map((item) => {
        arr.push(item.shift_uuid);
      });
      return arr;
    },
  },
  data() {
    return {
      RosterPropertyGroupData: [],
      showNewShift: false,
      isChanged: false,
      showSelect: false,
      curShiftUuid: null,
      showPGDelete: false,
      iSEdited: false,
      rosterFormData: {
        roster_form_name: "",
        roster_form_description: "",
        roster_property_group_uuid: "",
        roster_default_time_zone: "480",
        remarks: "",
      },
      desserts: [],
      headers: [
        {
          text: "label_essweb_shiftType_list_shiftTypeNameLabel",
          value: "shift_type",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_shift_list_shiftNameLabel",
          value: "shift_name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_rosterForm_form_list_shiftTimeLabel",
          value: "time",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
      data_save: null,
    };
  },
  watch: {},
  mounted() {
    this.rosterFormData.roster_form_name = this.$getCommonLangKey(
      this.companyLang
    );
    this.rosterFormData.roster_form_description = this.$getCommonLangKey(
      this.companyLang
    );
    this.rosterFormData.roster_default_time_zone = this.defaultUTC;
    this.getBtnPermissionList();
    this.getRosterPropertyGroup();
    this.getDetail();
    this.getRosterShift();
  },
  methods: {
    getRosterPropertyGroup: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_roster_form_master",
        url: "/roster-property-group/get-list/",
      }).then((res) => {
        that.RosterPropertyGroupData = res.data;
      });
    },
    getDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_roster_form",
        url: "/roster-form/get-details/",
        data: {
          uuid: this.$route.params.id,
        },
      }).then((res) => {
        res.data["roster_form_name_save"] = res.data.roster_form_name;
        res.data.roster_form_name = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.roster_form_name
        );
        res.data["roster_form_description_save"] =
          res.data.roster_form_description;
        res.data.roster_form_description = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.roster_form_description
        );
        that.data_save = res.data;
        that.rosterFormData = res.data;
      });
    },
    getRosterShift: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_map_roster_form_template_shift",
        url: "/roster-form-map/get-list/",
        data: {
          roster_form_uuid: this.$route.params.id,
        },
      }).then((res) => {
        that.desserts = res.data;
      });
    },

    toDeleteShift: function (uuid) {
      const that = this;
      this.curShiftUuid = uuid;
      this.$confirmDo(this.$t("label_essweb_shift_list_title")).then((res) => {
        if (res) that.toConfirmDeleteShift();
      });
    },
    toConfirmDeleteShift: function () {
      this.desserts = this.desserts.filter(
        (ele) => ele.uuid !== this.curShiftUuid
      );
    },
    onNewShift: function (obj) {
      const that = this;
      obj.map((item) => {
        item["shift_uuid"] = item["uuid"];
      });
      this.showNewShift = false;
      if (this.desserts.length <= 0) {
        this.desserts = obj;
      } else {
        let arr = [];
        let arr1 = [];
        let arr2 = [];
        this.desserts.map((item) => {
          arr1.push(item.shift_uuid);
        });
        obj.map((item) => {
          arr2.push(item.shift_uuid);
        });
        arr = arr1.filter(function (val) {
          return arr2.indexOf(val) > -1;
        });
        if (arr.length) {
          //有重复
          let dulpArr = obj.filter((ele) => {
            return arr.indexOf(ele.shift_uuid) != -1;
          });
          obj = obj.filter((ele) => {
            return arr.indexOf(ele.shift_uuid) == -1;
          });
          this.desserts = this.desserts.concat(obj);
          let arrString = [];
          dulpArr.map((item) => {
            arrString.push(that.$getCommonLangValue(item.shift_name));
          });
          that.$showMessage({
            text:
              that.$t("error_essweb_rosterForm_form_shiftExistLabel") +
              "<br/>" +
              arrString.join(","),
            type: "warning",
          });
        } else {
          this.desserts = this.desserts.concat(obj);
        }
        // this.desserts.some((item, index) => {
        //   if (item["shift_uuid"] === obj["shift_uuid"]) {
        //     that.$showMessage({
        //       title: that.$t("message_essweb_form_textField_errNoticeTitle"),
        //       okText: that.$t("message_essweb_form_textField_selectAgain"),
        //       text: that.$t("error_essweb_rosterForm_form_shiftExistLabel"),
        //       type: "error",
        //     });
        //     return true;
        //   }
        //   if (index == that.desserts.length - 1) {
        //     that.desserts.push(obj);
        //   }
        // });
      }
    },
    toBack: function (change) {
      if (change)
        this.$confirmWarn(
          this.$t("message_tips"),
          this.$t("message_essweb_form_textField_refuseChange_title")
        ).then((res) => {
          if (res) {
            if (this.iSEdited) {
              this.iSEdited = false;
              this.getDetail();
              this.getRosterShift();
            } else {
              this.$router.back();
            }
          }
        });
      else {
        if (this.iSEdited) {
          this.iSEdited = false;
          this.getDetail();
          this.getRosterShift();
        } else {
          this.$router.back();
        }
      }
    },
    toSave: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      let arrlist = [];
      this.desserts.map((item, index) => {
        let json = {};
        json["shift_uuid"] = item.shift_uuid;
        json["sequence"] = index + 1;
        json["remarks"] = "";
        arrlist.push(json);
      });
      this.$Request({
        method: "POST",
        table: "ess_att_roster_form",
        url: "/roster-form/update/",
        data: {
          uuid: this.$route.params.id,
          roster_form_name: this.$transCommonLangKey(
            this.rosterFormData.roster_form_name,
            this.rosterFormData.roster_form_name_save
          ),
          roster_form_description: this.$transCommonLangKey(
            this.rosterFormData.roster_form_description,
            this.rosterFormData.roster_form_description_save
          ),
          roster_property_group_uuid:
            this.rosterFormData.roster_property_group_uuid,
          roster_default_time_zone:
            this.rosterFormData.roster_default_time_zone,
          ess_att_map_roster_form_template_shift: arrlist,
          remarks: this.rosterFormData.remarks,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_RosterForm_list_updateRosterFormSuccessLabel"
          ),
          type: "success",
        });
        that.toBack();
      });
    },
    toDelete: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_roster_form",
        url: "/roster-form/delete/",
        data: {
          uuids: this.$route.params.id,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_RosterForm_list_deleteRosterFormSuccessLabel"
          ),
          type: "success",
        });
        that.toBack();
      });
    },
  },
};
</script>
